import { UpdateFn } from "../../types";
import useFetch from "../use-fetch";

const useWidgetFetch = <T,>(
  setter: UpdateFn<T[]>,
  getter: () => Promise<T[]>,
  cached: T[],
  onFinally?: () => void
) => {
  useFetch(setter, () => {
    return new Promise((resolve, reject) => {
      if (!cached.length) {
        getter()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            if (onFinally) onFinally();
          });
      } else {
        resolve(cached);
      }
    });
  });
};

export default useWidgetFetch;
